import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/27_card_back_owl/27_card_back_owl"
 * Contains 1 texture(s)
 */
export class CardsBacks27CardBackOwlAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/27_card_back_owl/27_card_back_owl';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '27_owl.png'
    ] as const;
}
